import FieldTypesEnum from "../Enums/FieldTypesEnum";
import IobLineItem from "./IobLineItem";

class IobLineItemFieldworkFees extends IobLineItem {
  static FieldsToShowInDataTable() {
    return [
      { label: "Apollo Assignment ID", orderById: "AssignmentApolloId", data: IobLineItem.idFunction },
      { label: "Type", orderById: "Type", data: "Type" },
      { label: "Status", orderById: "AssignmentStatus", data: "AssignmentStatus" },
      { label: "Country", orderById: "AssignmentCountryName", data: "AssignmentCountryName" },
      { label: "Amount", orderById: "Amount", data: "Amount" },
      { label: " ", orderById: "", data: IobLineItem.getActionsContent, type: FieldTypesEnum.ActionButton, className: "text-center" },
    ];
  }
}
export default IobLineItemFieldworkFees;
